var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5667 7.50003L3.50003 13.3334L2.45003 10.5334C2.10003 9.25003 2.80003 7.96669 3.96669 7.61669L19.7167 2.95003C21 2.60003 22.2834 3.30003 22.6334 4.46669L23.5667 7.50003Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23334 6.68335L10.85 11.2333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4667 4.46667L18.0833 9.13334",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.3333H24.5V22.6666C24.5 23.2855 24.2542 23.879 23.8166 24.3166C23.379 24.7541 22.7855 25 22.1667 25H5.83333C5.21449 25 4.621 24.7541 4.18342 24.3166C3.74583 23.879 3.5 23.2855 3.5 22.6666V13.3333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilm);
export default __webpack_public_path__ + "static/media/Icon-Film.51f82cdbf3a90ed04e9cadad4376b727.svg";
export { ForwardRef as ReactComponent };